
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8u6tU", function(module, exports) {

$parcel$export(module.exports, "EditorAppearanceButtonComponent", () => $7b6fda5754d8dda7$export$c864be1599adc41);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $js7oX = parcelRequire("js7oX");

var $3gadb = parcelRequire("3gadb");

var $4KS7f = parcelRequire("4KS7f");

var $1kVeP = parcelRequire("1kVeP");

var $64M9v = parcelRequire("64M9v");

var $1DWH0 = parcelRequire("1DWH0");

var $hp2SH = parcelRequire("hp2SH");

var $8VcPj = parcelRequire("8VcPj");
var $CTedk = parcelRequire("CTedk");
const $7b6fda5754d8dda7$var$i18n = (0, $2nPZH.defineMessages)({
    fixedWidth: {
        id: "editor-appearance-button.toggle.fixed.width",
        defaultMessage: "Make full-width"
    },
    fullWidth: {
        id: "editor-appearance-button.toggle.full.width",
        defaultMessage: "Make fixed-width"
    }
});
class $7b6fda5754d8dda7$var$EditorAppearanceButtonComponentClass extends (0, $gwFzn.PureComponent) {
    render() {
        const { isDisabled: isDisabled, intl: intl, isStatusDisconnected: isStatusDisconnected, updateContentAppearanceProperty: updateContentAppearanceProperty, contentAppearanceDraft: contentAppearanceDraft, contentId: contentId, collabEditProvider: collabEditProvider } = this.props;
        const i18nTooltipTextMessage = this.getTooltipText();
        const tooltipText = intl.formatMessage(i18nTooltipTextMessage);
        const apolloClient = (0, $hp2SH.getApolloClient)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8VcPj.ContentAppearanceButton), {
            userOffline: isStatusDisconnected,
            apolloClient: apolloClient,
            updateContentAppearanceProperty: updateContentAppearanceProperty,
            params: this._getToggleWidthParams(contentAppearanceDraft, contentId),
            collabEditProvider: collabEditProvider
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
            content: tooltipText,
            tag: "span",
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KS7f.default), {
            ref: this.buttonRef,
            appearance: "subtle",
            iconBefore: this.getButtonIcon(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                minWidth: 36
            },
            onClick: this.toggleWidth(apolloClient),
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            isDisabled: !Boolean((0, window.__SSR_RENDERED__)) && isDisabled,
            "data-test-id": "editor-appearance-button"
        })));
    }
    constructor(...args){
        super(...args);
        this.buttonRef = /*#__PURE__*/ (0, $gwFzn.createRef)();
        this._triggerAnalyticsEvent = (eventName, extraData = {})=>{
            const { contentId: contentId, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const analyticDetails = {
                contentId: contentId,
                ...extraData
            };
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: eventName,
                    actionSubject: 'updateContentAppearanceDraft',
                    source: 'EditContentAppearanceButtonComponent',
                    attributes: analyticDetails
                }
            }).fire();
        };
        this._isFullWidth = (contentAppearanceDraft)=>{
            return contentAppearanceDraft.appearance === (0, $CTedk.ContentAppearanceType).FULL_WIDTH;
        };
        this._getToggleWidthParams = (contentAppearanceDraft, contentId)=>{
            const newAppearance = this._isFullWidth(contentAppearanceDraft) ? (0, $CTedk.ContentAppearanceType).DEFAULT : (0, $CTedk.ContentAppearanceType).FULL_WIDTH;
            const newVersion = contentAppearanceDraft.version ? contentAppearanceDraft.version + 1 : 1;
            return {
                contentId: contentId || '',
                propertyKey: (0, $CTedk.ContentAppearancePropertyKey).DRAFT,
                propertyValue: newAppearance,
                versionNumber: newVersion
            };
        };
        this.toggleWidth = (apolloClient)=>async ()=>{
                const { contentAppearanceDraft: contentAppearanceDraft, contentId: contentId, updateContentAppearanceProperty: updateContentAppearanceProperty, collabEditProvider: collabEditProvider } = this.props;
                const wasFocused = document.activeElement === this.buttonRef.current;
                if (contentId) {
                    let params = this._getToggleWidthParams(contentAppearanceDraft, contentId);
                    params = await (0, $8VcPj.updateContentAppearancePropertyWithRetry)(updateContentAppearanceProperty, params, apolloClient, collabEditProvider);
                    this._triggerAnalyticsEvent('content.appearance.draft', {
                        appearance: params.propertyValue,
                        previousAppearance: contentAppearanceDraft.appearance,
                        appearanceVersion: params.versionNumber
                    });
                    if (wasFocused) this.buttonRef.current?.focus();
                }
            };
        this.getTooltipText = ()=>{
            const { contentAppearanceDraft: contentAppearanceDraft } = this.props;
            if (this._isFullWidth(contentAppearanceDraft)) return $7b6fda5754d8dda7$var$i18n.fullWidth;
            return $7b6fda5754d8dda7$var$i18n.fixedWidth;
        };
        this.getButtonIcon = ()=>{
            const { intl: intl, contentAppearanceDraft: contentAppearanceDraft } = this.props;
            const i18nTooltipTextMessage = this.getTooltipText();
            const label = intl.formatMessage(i18nTooltipTextMessage);
            if (this._isFullWidth(contentAppearanceDraft)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($64M9v))), {
                color: "currentColor",
                spacing: "spacious",
                label: label
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1kVeP))), {
                color: "currentColor",
                spacing: "spacious",
                label: label
            });
        };
    }
}
const $7b6fda5754d8dda7$export$c864be1599adc41 = (0, $js7oX.default)((0, $1DWH0.default)()($7b6fda5754d8dda7$var$EditorAppearanceButtonComponentClass));

});
parcelRegister("1kVeP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da1cd6bc83afe2b3eb4120a294491d29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f940f03e44f9ec9$var$_react = $0f940f03e44f9ec9$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $0f940f03e44f9ec9$var$_baseNew = $0f940f03e44f9ec9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0f940f03e44f9ec9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f940f03e44f9ec9$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $0f940f03e44f9ec9$var$_react.default.createElement($0f940f03e44f9ec9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m.22 7.47 3.5-3.5 1.06 1.06-2.22 2.22H7v1.5H2.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06m13.22-.22-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H9v-1.5z" clip-rule="evenodd"/>`
    }, props));
$0f940f03e44f9ec9$var$GrowHorizontalIcon.displayName = 'GrowHorizontalIcon';
var $0f940f03e44f9ec9$var$_default = module.exports.default = $0f940f03e44f9ec9$var$GrowHorizontalIcon;

});

parcelRegister("64M9v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a9e4799467251fb8d42dd325d017373>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46c877d9e4f2db1d$var$_react = $46c877d9e4f2db1d$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $46c877d9e4f2db1d$var$_baseNew = $46c877d9e4f2db1d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $46c877d9e4f2db1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $46c877d9e4f2db1d$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $46c877d9e4f2db1d$var$_react.default.createElement($46c877d9e4f2db1d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 8.75H0v-1.5h6.25zm3.5-1.5H16v1.5H9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M5.19 8 2.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06zm4.03-.53 3.5-3.5 1.06 1.06L10.81 8l2.97 2.97-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$46c877d9e4f2db1d$var$ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIcon';
var $46c877d9e4f2db1d$var$_default = module.exports.default = $46c877d9e4f2db1d$var$ShrinkHorizontalIcon;

});



//# sourceMappingURL=EditorAppearanceButtonComponent.e2ea0a9e.js.map
